import { baseRequest } from "../axiosconfig";
import { downloadFile } from "./download";

export const ACCEPTED_EXTENSIONS = ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png";
export const ACCEPTED_EXTENSIONS_LABEL = "PDF, DOC, DOCX, XLS, XLSX, JPG i PNG";
export const MAX_FILE_SIZE_MB = 25;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
const ALLOWED = ACCEPTED_EXTENSIONS.split(",").map((e) => e.replace(".", ""));

// Brza provera na klijentu radi bolje poruke; server ostaje merodavan.
export function validateFileLocally(file) {
  if (!file) return "Fajl nije izabran.";
  const ext = String(file.name || "").split(".").pop().toLowerCase();
  if (!file.name.includes(".") || !ALLOWED.includes(ext)) {
    return `Tip fajla nije dozvoljen. Dozvoljeni su ${ACCEPTED_EXTENSIONS_LABEL}.`;
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return `Fajl je veći od dozvoljenih ${MAX_FILE_SIZE_MB} MB.`;
  }
  return null;
}

// Otprema fajl i vraća zapis dokumenta (bez activity_id, vezuje se pri snimanju reda).
export async function uploadActivityDocument(processMapId, file) {
  const formData = new FormData();
  formData.append("process_map_id", String(processMapId));
  formData.append("file", file, file.name);
  // Content-Type se ne postavlja ručno: axios sam dodaje multipart granicu
  const res = await baseRequest.post("/activity_document", formData);
  return res.data.data;
}

export function uploadErrorMessage(error) {
  const status = error?.response?.status;
  if (status === 403) return "Nemate ovlašćenje za ovu akciju.";
  const serverMessage = error?.response?.data?.message;
  if ([413, 415, 422, 503, 404].includes(status) && serverMessage) return serverMessage;
  return "Otpremanje nije uspelo.";
}

export function downloadActivityDocument(doc) {
  return downloadFile(`/activity_document/${doc.id}/download`, doc.name || "dokument", {
    errorMessage: "Preuzimanje nije uspelo.",
  });
}
